<template>
    <div>
        <div class="ix-comments-loader" v-if="loading">
            <i class="far fa-circle-notch fa-spin"></i> Chargement des pointages
        </div>

        <div class="ix-sidebar ix-sidebar-large" id="checking-sidebar">
            <div class="ix-sidebar-header">
                <h2 class="ix-sidebar-title"></h2>
                <button class="ix-sidebar-btn-close trigger-close-sidebar">
                    <i class="fal fa-times"></i>
                </button>
            </div>

            <div class="ix-sidebar-content">
                <div class="ix-comments-loader" v-if="loadingShow">
                    <i class="far fa-circle-notch fa-spin"></i> Récupération du pointage
                </div>

                <div v-if="!loadingShow && selectedChecking">
                    <div class="text-center mb-2" v-if="selectedChecking.user">
                        <a :href="userRoute + '/' + selectedChecking.user.id" class="ix-link">
                            <span class="ix-avatar">
                                <img :src="selectedChecking.user.avatar_path" v-if="selectedChecking.user.avatar_path">
                                <span v-if="!selectedChecking.user.avatar_path">{{ selectedChecking.user.initial }}</span>
                            </span>
                            <span class="ix-checking-sidebar-fullname">{{ selectedChecking.user.fullname }}</span>
                        </a>
                    </div>
                    <div class="text-center mb-2" v-if="selectedChecking.equipment">
                        <a :href="equipmentRoute + '/' + selectedChecking.equipment.id" class="ix-link">
                            <span class="ix-avatar">
                                <img :src="selectedChecking.equipment.avatar_path" v-if="selectedChecking.equipment.image_path">
                            </span>
                            <span class="ix-checking-sidebar-fullname">{{ selectedChecking.equipment.name }}</span>
                        </a>
                    </div>

                    <div v-if="selectedChecking.absence">
                        <div class="ix-checking-sidebar-date">
                             Absence du {{ selectedChecking.absence.start_at | formatDate('DD MMMM YYYY') }} - {{ selectedChecking.absence.start_moment == 1 ? 'matin' : 'après-midi' }} au {{ selectedChecking.absence.end_at | formatDate('DD MMMM YYYY') }} - {{ selectedChecking.absence.end_moment == 1 ? 'matin' : 'après-midi' }} (inclus)
                        </div>
                    </div>

                    <div v-if="selectedChecking.type  == 1">
                        <div class="ix-checking-sidebar-date mb-2">
                            {{ selectedChecking.start_at | formatDate }}
                        </div>

                        <div class="ix-checking-sidebar-durations">
                            <div class="row">
                                <div class="col-sm-3" v-if="selectedChecking.duration != null">
                                    <div class="ix-checking-sidebar-duration">
                                        <span class="ix-checking-sidebar-duration-icon">
                                            <i class="far fa-clock"></i>
                                        </span>
                                        <span class="ix-checking-sidebar-duration-value">{{ selectedChecking.duration }}</span>
                                        <span class="ix-checking-sidebar-duration-label">Durée</span>
                                    </div>
                                </div>

                                <div class="col-sm-3" v-if="selectedChecking.night_hours > 0">
                                    <div class="ix-checking-sidebar-duration" style="border-color: #6366f1;">
                                        <span class="ix-checking-sidebar-duration-icon" style="color: #6366f1;">
                                            <i class="far fa-moon"></i>
                                        </span>
                                        <span class="ix-checking-sidebar-duration-value" style="color: #6366f1;">
                                            {{ formatHours(selectedChecking.night_hours) }}
                                        </span>
                                        <span class="ix-checking-sidebar-duration-label">Hrs de nuit</span>
                                    </div>
                                </div>

                                <div class="col-sm-3" v-if="selectedChecking.overtime_hours > 0">
                                    <div class="ix-checking-sidebar-duration" style="border-color: #f59e0b;">
                                        <span class="ix-checking-sidebar-duration-icon" style="color: #f59e0b;">
                                            <i class="far fa-hourglass-half"></i>
                                        </span>
                                        <span class="ix-checking-sidebar-duration-value" style="color: #f59e0b;">
                                            {{ formatHours(selectedChecking.overtime_hours) }}
                                        </span>
                                        <span class="ix-checking-sidebar-duration-label">Hrs supp.</span>
                                    </div>
                                </div>

                                <div class="col-sm-3" v-if="selectedChecking.route != null">
                                    <div class="ix-checking-sidebar-duration">
                                        <span class="ix-checking-sidebar-duration-icon">
                                            <i class="far fa-car"></i>
                                        </span>
                                        <span class="ix-checking-sidebar-duration-value">{{ selectedChecking.route }}</span>
                                        <span class="ix-checking-sidebar-duration-label">Tps de route</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="mt-4">
                            <div class="ix-bloc-simple-line">
                                <h3 class="ix-bloc-simple-line-title">Date de création</h3>
                                {{ selectedChecking.created_at | formatDate }}
                            </div>
                            <div class="ix-bloc-simple-line" v-if="selectedChecking.validated_at">
                                <h3 class="ix-bloc-simple-line-title">Date de validation</h3>
                                {{ selectedChecking.validated_at | formatDate }}
                            </div>
                            <div class="ix-bloc-simple-line" v-if="canValid && selectedChecking.user">
                                <h3 class="ix-bloc-simple-line-title">Taux horaire MO appliqué</h3>
                                {{ currency(selectedChecking.hourly_rate) }}/h
                            </div>
                            <div class="ix-bloc-simple-line" v-if="canValid && selectedChecking.user">
                                <h3 class="ix-bloc-simple-line-title">Taux horaire Temps de route appliqué</h3>
                                {{ currency(selectedChecking.route_hourly_rate) }}/h
                            </div>
                            <div class="ix-bloc-simple-line" v-if="canValid && selectedChecking.rate_type">
                                <h3 class="ix-bloc-simple-line-title">Majoration appliquée</h3>
                                <span class="badge badge-info">{{ selectedChecking.rate_type_label }}</span>
                            </div>
                            <div class="ix-bloc-simple-line" v-if="canValid && selectedChecking.base_cost">
                                <h3 class="ix-bloc-simple-line-title">Coût de base</h3>
                                {{ currency(selectedChecking.base_cost) }}
                            </div>
                            <div class="ix-bloc-simple-line" v-if="canValid && selectedChecking.bonus_cost > 0">
                                <h3 class="ix-bloc-simple-line-title">Coût majoration</h3>
                                <span class="ix-text-bold" style="color: #10b981;">+{{ currency(selectedChecking.bonus_cost) }}</span>
                            </div>
                            <div class="ix-bloc-simple-line" v-if="canValid">
                                <h3 class="ix-bloc-simple-line-title">Coût total</h3>
                                <span class="ix-text-bold">{{ currency(selectedChecking.cost) }}</span>
                            </div>
                            <div class="ix-bloc-simple-line" v-if="selectedChecking.mission">
                                <h3 class="ix-bloc-simple-line-title">Ordre de mission</h3>
                                <a :href="missionRoute + '/' + selectedChecking.mission.id">{{ selectedChecking.mission.number }} - {{ selectedChecking.mission.designation }}</a>
                            </div>
                            <div class="ix-bloc-simple-line" v-if="selectedChecking.deal">
                                <h3 class="ix-bloc-simple-line-title">Affaire</h3>
                                <a :href="dealRoute + '/' + selectedChecking.deal.id">{{ selectedChecking.deal.number }} - {{ selectedChecking.deal.name }}</a>
                            </div>
                             <div class="ix-bloc-simple-line" v-if="selectedChecking.intervention">
                                <h3 class="ix-bloc-simple-line-title">Intervention</h3>
                                <a :href="interventionRoute + '/' + selectedChecking.intervention.id">{{ selectedChecking.intervention.number }} - {{ selectedChecking.intervention.name }}</a>
                            </div>
                            <div class="ix-bloc-simple-line" v-if="selectedChecking.is_bad_weather">
                                <h3 class="ix-bloc-simple-line-title">Intempéries</h3>
                                <span class="badge badge-warning">Oui</span>
                            </div>
                            <div class="ix-bloc-simple-line" v-if="selectedChecking.description">
                                <h3 class="ix-bloc-simple-line-title">Informations additionnelles</h3>
                                <span v-html="nl2br(selectedChecking.description)"></span>
                            </div>
                            <div class="ix-bloc-simple-line" v-if="selectedChecking.lot">
                                <h3 class="ix-bloc-simple-line-title">Lot</h3>
                                <a :href="dealRoute+'/'+selectedChecking.deal.id+'/lots/'+selectedChecking.lot.id">{{ selectedChecking.lot.number }} - {{ selectedChecking.lot.name }}</a><br>
                                <span v-if="selectedChecking.operation">{{ selectedChecking.operation.designation }}</span>
                            </div>
                        </div>
                    </div>


                    <div v-if="selectedChecking.bonuses.length" class="mt-4">
                        <h2 class="ix-page-title-secondary">Primes associées</h2>
                        <div class="ix-table-box">
                            <table class="ix-table ix-table-sm">
                                <tbody>
                                    <tr v-for="(bonus, index) in selectedChecking.bonuses" :key="index">
                                        <td>{{ bonus.designation }}</td>
                                        <td>{{ bonus.pivot.details }} <span v-if="bonus.type == 3">km</span></td>
                                        <td class="text-right" v-if="canValid">{{ currency(bonus.pivot.cost) }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <div class="ix-checking-sidebar-actions mt-4">
                        
                        <button type="button" class="ix-btn ix-btn-block ix-btn-state mb-2" v-bind:disabled="loadingState"  v-if="canValid && selectedChecking.validated_at == null && selectedChecking.is_editable" @click="validate(selectedChecking)">
                            <span v-if="!loadingState"><i class="far fa-check"></i> Valider</span>
                            <span v-if="loadingState"><i class="far fa-circle-notch fa-spin"></i> Validation en cours</span>
                        </button>

                        <div class="ix-text-small ix-text-orange mb-2" v-if="canValid && !canValidMovement && selectedChecking.validated_at == null && selectedChecking.is_editable">
                            <i class="fas fa-exclamation-triangle"></i> Les mouvements de stocks ne seront pas validés
                        </div>

                        <a :href="selectedChecking.edit_url" class="ix-btn ix-btn-block mb-2" v-if="selectedChecking.edit_url && selectedChecking.validated_at == null && selectedChecking.state == 1"><i class="far fa-pen"></i> Modifier</a>


                        <button type="button" class="ix-btn ix-btn-block transparent" v-bind:disabled="loadingDelete" v-if="selectedChecking.is_deletable" @click="deleteChecking(selectedChecking)">
                            <span v-if="!loadingDelete"><i class="far fa-trash"></i> Supprimer</span>
                            <span v-if="loadingDelete"><i class="far fa-circle-notch fa-spin"></i> Suppression en cours</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <div class="ix-table-box ix-absence-table-box" v-if="!loading">
            <table class="ix-absence-table ix-checkings">
                <thead>
                <tr>
                    <th class="ix-absence-table-empty-cell text-center">
                        <a :href="previousUrl" class="ix-absence-table-navigation-button">
                            <i class="far fa-angle-left"></i>
                        </a>
                        <a :href="nextUrl" class="ix-absence-table-navigation-button">
                            <i class="far fa-angle-right"></i>
                        </a>
                    </th>
                    <th v-for="(month, index) in table.months" :key="index" :colspan="month.span" class="ix-absence-cell-month">
                        {{ month.label }} {{ month.year }}
                    </th>
                </tr>
                <tr>
                    <th class="ix-absence-table-empty-cell"></th>
                    <th v-for="(week, index) in table.weeks" :key="index" :colspan="week.span" class="ix-absence-cell-week">
                        <span>S{{ week.number }}</span>
                    </th>
                </tr>
                <tr>
                    <th class="ix-absence-table-empty-cell">
                    </th>
                    <th v-for="(day, index) in table.days" :key="index" class="ix-absence-cell-day" v-bind:class="{ 'ix-absence-cell-weekend': day.is_weekend, 'ix-absence-cell-not-working': day.is_not_working, 'ix-absence-cell-today': day.is_today }">
                        <span class="ix-triangle-indicator" v-if="day.is_today"></span>
                        {{ day.label }} <br>
                        {{ day.day }}
                    </th>
                </tr>
                </thead>
                <tbody>
                <tr  v-for="(row, dataIndex) in table.data" :key="dataIndex">
                    <td v-if="row.user">
                        {{ row.user.fullname }}
                        <div>
                            <div class="ix-checkings-total-hours d-inline-block" v-if="row.user.total_hours > 0">{{ row.user.total_hours.toFixed(2) }}h</div>
                            <div v-if="row.user.total_max_hours_week && row.user.total_max_hours_week < row.user.total_hours" class="ix-checkings-total-hours-danger d-inline-block">
                                {{ formatHours((row.user.total_hours - row.user.total_max_hours_week).toFixed(2)) }} supp.
                            </div>
                        </div>
                    </td>
                    <td v-if="row.equipment">
                        {{ row.equipment.fullname }}
                        <div>
                            <div class="ix-checkings-total-hours d-inline-block" v-if="row.equipment.total_hours > 0">{{ row.equipment.total_hours.toFixed(2) }}h</div>
                        </div>
                    </td>
                  
                    <td v-for="(day, dayIndex) in row.days" class="ix-absence-cell" :key="dayIndex" v-bind:class="{'ix-checking-day-warning': day.total_hours > maxHoursPerDay}">
                       
                        <div v-if="day.checkings">
                            <div v-if="day.previous_badgeings">
                                <div v-for="(badgeing, badgeingIndex) in day.previous_badgeings" :key="badgeingIndex" class="ix-checkings-total-hours d-inline-block mb-1" style="width: 100% !important;" v-bind:style="{'background' : badgeing.type == 0 ? '#077FD4 !important' : '#758495 !important'}">
                                    <span v-if="badgeing.type == 0">Arrivée : </span>
                                    <span v-if="badgeing.type == 1">Départ :</span>
                                     {{ badgeing.hours_at }}
                                </div>
                            </div>
                            <button class="ix-checking-card trigger-sidebar" v-for="(checking, checkingIndex) in day.checkings" :key="checkingIndex" type="button" @click="openChecking(checking.id)" v-bind:class="{'transluent': checking.state == 1, 'yellow': checking.is_bad_weather}" v-bind:style="{'background' : checking.color, 'color': checking.color ? '#fff' : ''}">
                                <span class="d-block ix-text-bold" v-if="checking.absence_designation">
                                    <i class="far fa-user-slash"></i> {{ checking.absence_designation }}
                                </span>
                                <span class="d-block ix-text-bold" v-if="checking.intervention_designation">
                                    <i class="far fa-wrench"></i> {{ checking.intervention_designation }}
                                </span>
                                <span class="d-block ix-text-bold" v-if="checking.deal_designation">
                                    <i class="far fa-folder"></i> {{ checking.deal_designation }}
                                </span>
                                <span class="d-block ix-text-bold" v-if="checking.is_bad_weather">
                                    <i class="far fa-cloud-sleet"></i> Intempéries
                                </span>
                                <span class="d-block" v-if="checking.deal_designation || checking.intervention_designation">
                                    <i class="far fa-clock"></i> {{ checking.start_time }} - {{ checking.duration }}h
                                </span>
                                <span class="d-block ix-text-bold" style="color: #6366f1;" v-if="checking.night_hours > 0">
                                    <i class="far fa-moon"></i> {{ formatHours(checking.night_hours) }} de nuit
                                </span>
                            </button>

                            <div class="ix-checkings-total-hours" v-if="day.total_hours > 0">{{ day.total_hours.toFixed(2) }}h </div>
                             <div class="ix-checkings-total-hours-danger" v-if="day.hours_per_day && day.hours_per_day > 0 && day.total_hours > day.hours_per_day">
                                  {{ formatHours((day.total_hours - day.hours_per_day).toFixed(2)) }} supp.
                            </div>
                            <div v-if="day.next_badgeings">
                                <div v-for="(badgeing, badgeingIndex) in day.next_badgeings" :key="badgeingIndex" class="ix-checkings-total-hours d-inline-block mt-1" style="width: 100% !important;" v-bind:style="{'background' : badgeing.type == 0 ? '#077FD4 !important' : '#758495 !important'}">
                                    <span v-if="badgeing.type == 0">Arrivée : </span>
                                    <span v-if="badgeing.type == 1">Départ :</span>
                                    {{ badgeing.hours_at }}
                                </div>
                            </div>
       
                        </div>
                        <div v-if="day.all_badgings">
                            <div v-for="(badging, badgingIndex) in day.all_badgings" :key="badgingIndex" class="ix-checkings-total-hours d-inline-block mt-1" style="width: 100% !important;" v-bind:style="{'background' : badging.type == 0 ? '#077FD4 !important' : '#758495 !important'}">
                                <span v-if="badging.type == 0">Arrivée : </span>
                                <span v-if="badging.type == 1">Départ :</span>
                                {{ badging.hours_at }}
                            </div>
                        </div>
                    </td>
                </tr>
                <tr v-if="table.data.length == 0">
                    <td></td>
                    <td :colspan="table.days.length" class="text-center">
                       <span v-if="typeChecking == 1">Il n'y a pas de salariés sous contrat durant la période demandée</span>
                       <span v-if="typeChecking == 2">Il n'y a pas de matériels durant la période demandée</span>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
    import Swal from "sweetalert2";

    
    const TYPE_CHECKING_USER = 1;
    const TYPE_CHECKING_EQUIPMENT = 2;

    export default {
        name: "CheckingsTable",
        props : {
            admin : Number,
            url : String,
            urlEquipment: String,
            canValid: Boolean,
            dealRoute: String,
            userRoute: String,
            equipmentRoute: String,
            interventionRoute: String,
            missionRoute: String,
            nextUrl: String,
            previousUrl: String,
            checkingIdToOpen: String,
            canValidMovement: Boolean,
            type: Number,
            maxHoursPerDay: {
                type: Number,
                default: 12
            },
        },
        data() {
            return {
                loading: true,
                loadingShow: false,
                loadingDelete: false,
                loadingState: false,
                is_admin : this.admin || false,
                table : {
                    days: [],
                    weeks: [],
                    months: [],
                    data: []
                },
                selectedChecking: null,
                typeChecking: this.type ? this.type : TYPE_CHECKING_USER,
            }
        },
        methods : {
            openChecking: function(checkingId){
                this.selectedChecking = null
                this.loadingShow = true

                $('#list-filters').removeClass('open');
                $('#checking-sidebar').addClass('open');

                fetch(this.url + '/' + checkingId, {
                    ...{
                        method: 'GET'
                    },
                    ...this.getHttpJsonRequestHeaders()
                }).then((response) => {
                    this.loadingShow = false;
                    if (response.status == 200) {
                        response.json().then((data) => {
                            this.selectedChecking = data
                        })
                    } else {
                        this.closeCheckingSidebar()
                    }
                }).catch(error => {
                    this.loadingShow = false;
                    this.closeCheckingSidebar()
                    console.log(error)
                });
            },
            closeCheckingSidebar: function(){
                this.selectedChecking = null
                this.loadingShow = false
                $('#checking-sidebar').removeClass('open');
            },
            searchCheckingInTable: function(checking){
                var objectIndex = this.table.data.findIndex(object => {
                    if(object.user)
                        return object.user.id == checking.user_id
                    if(object.equipment)
                        return object.equipment.id == checking.equipment_id
                })

                if (objectIndex >= 0) {
                    var dayIndex = this.table.data[objectIndex].days.findIndex(day => {
                        return day.date == this.$options.filters.formatDate(checking.start_at, 'DD/MM/YYYY')
                    })

                    if (dayIndex >= 0) {
                        if (this.table.data[objectIndex].days[dayIndex].checkings && this.table.data[objectIndex].days[dayIndex].checkings.length > 0) {
                            var checkingIndex = this.table.data[objectIndex].days[dayIndex].checkings.findIndex(c => {
                                return c.id == checking.id
                            })

                            if (checkingIndex >= 0) {
                                return {
                                    'objectIndex': objectIndex,
                                    'dayIndex': dayIndex,
                                    'checkingIndex': checkingIndex,
                                }
                            }
                        }
                    }
                }

                return null
            },
            async getData(){
                this.loading = true;
                let url = this.typeChecking == TYPE_CHECKING_USER ? this.url : this.urlEquipment;
                fetch(url + window.location.search  , {
                    ...{
                        method: 'GET'
                    },
                    ...this.getHttpJsonRequestHeaders()
                }).then((response) => {
                    this.loading = false;
                    if (response.status == 200) {
                        response.json().then((data) => {
                            this.table.days = data.days
                            this.table.weeks = data.weeks
                            this.table.months = data.months
                            this.table.data = data.data
                        })
                    }
                }).catch(error => {
                    this.loading = false;
                    console.log(error)
                });
            },
            async validate(checking) {
                Swal.fire({
                    title: 'Êtes-vous sûr ?',
                    text: "Le pointage ne sera plus modifiable",
                    icon: 'warning',
                    showCancelButton: true,
                    cancelButtonText: 'Annuler',
                    confirmButtonText: 'Valider',
                    reverseButtons: true,
                    heightAuto: false
                }).then((result) => {
                    if (result.value) {
                        this.loadingState = true

                        fetch(this.url + '/' + checking.id + '/valid' , {
                            ...this.getHttpJsonRequestHeaders(),
                            ...{
                                method : "PUT",
                                body :  ""
                            }
                        }).then((response) => {
                            this.loadingState = false

                            if (response.status == 200) {
                                response.json().then((data) => {
                                    var newState = data.state
                                    var newValidatedAt = data.validated_at

                                    checking.state = newState;
                                    checking.validated_at = newValidatedAt

                                    // Mise à jour du pointage dans le tableau
                                    var indexes = this.searchCheckingInTable(data)
                                    if (indexes != null) {
                                        this.table.data[indexes.objectIndex].days[indexes.dayIndex].checkings[indexes.checkingIndex].state = newState
                                    }
                                })
                            }
                        }).catch(error=> {
                            this.loadingState = false
                            console.log(error);
                        })
                    }
                })
            },
            async deleteChecking(checking){
                this.$swal({
                    title : "Êtes vous sûr ?",
                    text : "Le pointage sera définitivement supprimé",
                    icon : "warning",
                    dangerMode : true,
                    buttons : ["Annuler" , "Supprimer"]
                }).then((willDo) => {
                    if(willDo){
                        this.loadingDelete = true

                        fetch(this.url + "/" + checking.id , {
                            ...{
                                method: 'DELETE'
                            },
                            ...this.getHttpJsonRequestHeaders()
                        }).then(async (response) => {
                            if (response.status == 200) {
                                window.location.reload()
                            } else {
                                this.loadingDelete = false
                            }
                        }).catch(error => {
                            this.loadingDelete = false
                            console.log(error);
                        })

                    }
                });
            },
        },

        async mounted(){
            await this.getData();

            if (this.checkingIdToOpen != null && this.checkingIdToOpen != '') {
                this.openChecking(this.checkingIdToOpen)
            }
        }
    }
</script>
